const Icon = ({ path, width, height }) => (
  <i
    style={{
      display: "inline-block",
      width: width ? width : "30px",
      height: height ? height : "30px",
      color: "white",
      backgroundImage: `url("${path}")`,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    }}
  ></i>
);

export default Icon;
